import { render, staticRenderFns } from "./PageUnauthorized.vue?vue&type=template&id=18f453b6&scoped=true&"
import script from "./PageUnauthorized.vue?vue&type=script&lang=js&"
export * from "./PageUnauthorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f453b6",
  null
  
)

export default component.exports